import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center gap-space-1 px-space-2 py-[4px] whitespace-nowrap " +
    "font-display text-[10px] font-bold uppercase tracking-[0.16em] rounded-sm",
  {
    variants: {
      status: {
        draft:     "bg-onyx text-white-pure",
        review:    "bg-status-warning text-white-pure",
        finalized: "bg-status-success text-white-pure",
        archived:  "bg-transparent text-gray-mid border border-gray-mid",
        error:     "bg-status-error text-white-pure",
        info:      "bg-status-info text-white-pure",
        gold:      "bg-gold text-onyx",
      },
    },
    defaultVariants: { status: "draft" },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, status, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ status }), className)} {...props} />;
}

export { badgeVariants };
